// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconTea = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M4.18 18.166L3 4h16l-.175 2.104c.852.22 1.573.77 2.096 1.468C21.606 8.485 22 9.7 22 11s-.394 2.515-1.079 3.428C20.236 15.342 19.214 16 18 16l-.18 2.166A2 2 0 0115.826 20H6.174a2 2 0 01-1.993-1.834m13.988-4.177c.393-.053.803-.293 1.153-.76.401-.535.679-1.32.679-2.229 0-.91-.278-1.694-.679-2.228a2.1 2.1 0 00-.669-.6zM6.174 18l-1-12H11v4.357l-1 .357V15h4v-4.286l-1-.357V6h3.826l-1 12z"
    />
  );
export default SvgIconTea;
